import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import { saveAs } from 'file-saver';

import Table from 'Components/Table';
import Icon from 'Components/Icon/Icon';
import logoDownload from '../../../../assets/dm-download.svg';
import logoPrint from '../../../../assets/dm-print.svg';
import formatDate from 'Shared/util/formatDate';
import formatPrice from 'Shared/util/formatPrice';
import CustomRowComponent from 'Components/CustomRowComponent/CustomRowComponent';

import { getOrder, getIssued, getTotal, getInvoices, getBalance } from 'Shared/util/getColumns';

const TabInProgressTable = ({ orders }) => {
  const history = useHistory();
  const [openDownMenu, setOpenDownMenu] = useState(null);

  const redirectInvoices = (event, id) => {
    event.preventDefault();
    history.push(`/customer/invoice/detail/${id}`);
  };

  const handleEvent = (event, payload) => {
    event.preventDefault();

    switch (payload.type) {
      case 'download':
        saveAs(payload.url, `${payload.title}.pdf`);
        break;
      case 'setOpenDownMenu':
        setOpenDownMenu(payload.id);
        break;
      case 'print':
        window.open(payload.url, 'PRINT', 'height=400,width=600');
        break;
      default:
        console.error(`Warning: there are no such options (${payload.type}) `);
    }
  };

  const columns = [
    getOrder(),
    getIssued(170),
    getInvoices(267, redirectInvoices),
    getBalance(180),
    getTotal(180),
    {
      cellProps: {
        Header: () => <span className="filter-title"> </span>,
        Cell: (props) => {
          const id = props.row._original.id;
          return (
            <>
              <span className="rt-td__head"> </span>
              <div className={'rt-td__cell'}>
                <div className="orders-tab-nav-container">
                  <button
                    data-testid="btn-points"
                    className="orders-tab-nav-container__btn-points"
                    onClick={(event) => handleEvent(event, { type: 'setOpenDownMenu', id })}
                  >
                    • • •
                  </button>
                  <div className="orders-tab-nav-container__btn-next" data-testid="icon-right-in-progress">
                    <Icon name="icon-right" />
                  </div>
                  <ul
                    data-testid="dropdown-menu"
                    className={cn('orders-tab-nav-container__dropdown-menu', { 'action-menu': id === openDownMenu })}
                    onMouseLeave={(event) => handleEvent(event, { type: 'setOpenDownMenu', id: null })}
                    onClick={(event) => event.preventDefault()}
                  >
                    <li>
                      {props.row.download.url && (
                        <button
                          onClick={(event) =>
                            handleEvent(event, {
                              type: 'download',
                              url: props.row.download.url,
                              title: props.row.order.title,
                            })
                          }
                        >
                          <img src={logoDownload} alt="download" />
                          <span>Download</span>
                        </button>
                      )}
                    </li>
                    <li>
                      {props.row.download.url && (
                        <button onClick={(event) => handleEvent(event, { type: 'print', url: props.row.download.url })}>
                          <img src={logoPrint} alt="print" />
                          <span>Print</span>
                        </button>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            </>
          );
        },
        accessor: 'download',
        width: 130,
        sortable: false,
      },
    },
  ];

  const mapColleaguesDataToRows = useCallback((orders = []) => {
    const filteredOrders = orders.map(({ order, issued, total, download, balance, invoices, id }) => {
      return {
        order: {
          title: order.reference ? order.reference : '-',
          desc: order.slug ? order.slug : '-',
        },
        issued: {
          title: issued.date ? `${formatDate(issued.date)}` : '-',
        },
        total: {
          title: total.number && total.currency ? `${formatPrice(total.number)} ${total.currency}` : '-',
        },
        balance: {
          title: balance.number && balance.currency ? `${formatPrice(balance.number)} ${balance.currency}` : '-',
        },
        download: {
          url: download.url ? download.url : '',
        },
        invoices,
        id,
      };
    });

    return filteredOrders;
  }, []);

  const tableSettings = {
    paginationHeight: 56,
    pageSize: window.innerWidth > 767 ? 10 : 3,
    CustomRowComponent: (props) => <CustomRowComponent url={'/customer/order/detail/'} {...props} />,
  };

  return (
    <div className="tab-orders" data-testid="tab-orders-with-invoices">
      {orders && (
        <div className="table-wrap">
          <Table
            key="input-filter"
            sortable={false}
            tableSettings={tableSettings}
            columns={columns}
            data={mapColleaguesDataToRows(orders)}
          />
        </div>
      )}
    </div>
  );
};

export default TabInProgressTable;
